export const GET_PROPERTY_LIST = "/API/BookingEngineAPI/PropertyList";
export const GET_PROPERTY_DETAIL = "/API/BookingEngineAPI/PropertyDetails";
export const GET_PREBOOKING_DETAIL = "/API/BookingEngineAPI/PreBooking";
export const SAVE_CONFIRM_BOOKING = "/API/BookingEngineAPI/BookingCheckoutSave";
export const GET_ROOM_RESTRICTION = "/API/BookingEngineAPI/RateCodeRestrictionsCheck";

export const GET_TERMS_AND_CONDITIONS = "/api/BON/TermAndCond";



